import React, { useEffect, useRef, useState } from "react";

const OverallPortfolioSummaryCard = (props) => {
  const infoForm = useRef(null);
  const [overallSummaryData, setOverallSummaryData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [paymentMode, setPaymentMode] = useState(null);

  // OVERALL PORTFOLIO
  const getAdminDashboardOverviewSummary = (query, params) => {
    let data = {
      ...query,
      ...(paymentMode ? { paymentMode: paymentMode } : {}),
    };

    let payload = params ? { timeline: params } : { timeline: "ALL_TIME" };

    props.apis.apiGetAdminDashboardOverviewSummary(data, payload).then((res) => {
      const snapshot = res?.latestSnapshot || {};
      setOverallSummaryData((prevState) => ({
        ...prevState,
        overallBookCount: snapshot?.overallBook?.count || 0,
        overallBookAmount: snapshot?.overallBook?.amount || 0,
        activeCount: snapshot?.active?.count || 0,
        activeAmount: snapshot?.active?.amount || 0,
        closedCount: snapshot?.closed?.count || 0,
        closedAmount: snapshot?.closed?.amount || 0,
        grossOverdueCount: snapshot?.grossOverdue?.count || 0,
        grossOverdueAmount: snapshot?.grossOverdue?.amount || 0,
        partPaymentCount: snapshot?.partPayment?.count || 0,
        partPaymentAmount: snapshot?.partPayment?.amount || 0,
        netOverduePct: snapshot?.netOverduePct || 0,
        netOverdueAmount: snapshot?.netOverdue?.amount || 0,
        grossOverduePct: snapshot?.grossOverduePct || 0,
        mtdNetCount: snapshot?.mtd?.net?.count || 0,
        mtdNetAmount: snapshot?.mtd?.net?.amount || 0,
        mtdDisbursedLoansCount: snapshot?.mtd?.disbursed?.count || 0,
        mtdDisbursedLoansAmount: snapshot?.mtd?.disbursed?.amount || 0,
        mtdClosedCount: snapshot?.mtd?.closed?.count || 0,
        mtdClosedAmount: snapshot?.mtd?.closed?.amount || 0,
        mtdOverdueCount: snapshot?.mtd?.overdue?.count || 0,
        mtdOverdueAmount: snapshot?.mtd?.overdue?.amount || 0,
        ytdNetCount: snapshot?.ytd?.net?.count || 0,
        ytdNetAmount: snapshot?.ytd?.net?.amount || 0,
        ytdDisbursedLoansCount: snapshot?.ytd?.disbursed?.count || 0,
        ytdDisbursedLoansAmount: snapshot?.ytd?.disbursed?.amount || 0,
        ytdClosedCount: snapshot?.ytd?.closed?.count || 0,
        ytdClosedAmount: snapshot?.ytd?.closed?.amount || 0,
        ytdOverdueCount: snapshot?.ytd?.overdue?.count || 0,
        ytdOverdueAmount: snapshot?.ytd?.overdue?.amount || 0,
      }));
    });
  };

  const toggleInputs = (inputnames, hide = false) => {
    inputnames.forEach((id) => {
      const element = document.getElementById(id);
      if (element) hide ? element.classList.add("d-none") : element.classList.remove("d-none");
    });
  };

  const showInputs = (inputnames) => toggleInputs(inputnames, false);
  const hideInputs = (inputnames) => toggleInputs(inputnames, true);

  const handlePaymentModeChange = (value) => {
    let val = value[0]?.key || "";
    setPaymentMode(val === "ALL" ? null : val);
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = ["column-startDate", "column-endDate", "column-search_btn", "column-reset_btn"];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setOverallSummaryData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = { ...Object.except(data, ["timeline"]) };
    getAdminDashboardOverviewSummary(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    hideInputs(["column-startDate", "column-endDate", "column-search_btn", "column-reset_btn"]);
    getAdminDashboardOverviewSummary({}, "TODAY");
  };

  useEffect(() => {
    getAdminDashboardOverviewSummary();
  }, [timeline, paymentMode]);

  props.$setNode({ props, overallSummaryData });

  const renderCard = (card, i) => {
    const className = `col-12 col-md-6 col-lg-6 col-xl-3 metrics_card ${card.extraClass || ''}`.trim();
    if (card.pctKey) {
      return (
        <div key={i} className={className}>
          <div className="col_left">
            <div className="amnt_icon_circle">
              <span>{overallSummaryData?.[card.pctKey] || 0}</span>
            </div>
          </div>
          <div className="col_right">
            <h5 className="card-title">{card.title}</h5>
          </div>
        </div>
      );
    }
    return (
      <div key={i} className={className}>
        <div className="col_left">
          <img src={imagepaths[card.img]} className="lead_card_img" alt="card icon" />
        </div>
        <div className="col_right">
          <h5 className="card-title">{card.title}</h5>
          <div className="bottom_content">
            <p className="card-text">
              <span className="me-2">No. Of Applications :</span>
              <span>{overallSummaryData?.[card.countKey] || 0}</span>
            </p>
            <p className="card-text">
              <span className="me-2">Amount :</span>
              <span>{overallSummaryData?.[card.amountKey]?.cur() || 0}</span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const row1Cards = [
    { img: 'overallBookImg', title: 'Overall Book', countKey: 'overallBookCount', amountKey: 'overallBookAmount' },
    { img: 'dollarCheckImg', title: 'Active Book', countKey: 'activeCount', amountKey: 'activeAmount' },
    { img: 'dollarCloseImg', title: 'Closed Book', countKey: 'closedCount', amountKey: 'closedAmount' },
    { img: 'overdueBookImg', title: 'Gross Overdue', countKey: 'grossOverdueCount', amountKey: 'grossOverdueAmount' }
  ];

  const row2Cards = [
    { img: 'overdueBookImg', title: 'Part Payment', countKey: 'partPaymentCount', amountKey: 'partPaymentAmount' },
    { img: 'overdueBookImg', title: 'Net Overdue', countKey: 'netOverduePct', amountKey: 'netOverdueAmount' },
    { pctKey: 'netOverduePct', title: 'Net Overdue %' },
    { pctKey: 'grossOverduePct', title: 'Gross Overdue %', extraClass: 'border-right-0' },
    { img: 'overallBookImg', title: 'MTD Net Book', countKey: 'mtdNetCount', amountKey: 'mtdNetAmount' },
    { img: 'overallBookImg', title: 'MTD Disbursements', countKey: 'mtdDisbursedLoansCount', amountKey: 'mtdDisbursedLoansAmount' },
    { img: 'overallBookImg', title: 'MTD Closed Book', countKey: 'mtdClosedCount', amountKey: 'mtdClosedAmount' },
    { img: 'overallBookImg', title: 'MTD Gross Overdue', countKey: 'mtdOverdueCount', amountKey: 'mtdOverdueAmount', extraClass: 'border-right-0' },
    { img: 'dollarCheckImg', title: 'YTD Net Book', countKey: 'ytdNetCount', amountKey: 'ytdNetAmount' },
    { img: 'dollarCheckImg', title: 'YTD Disbursements', countKey: 'ytdDisbursedLoansCount', amountKey: 'ytdDisbursedLoansAmount' },
    { img: 'dollarCheckImg', title: 'YTD Closed Book', countKey: 'ytdClosedCount', amountKey: 'ytdClosedAmount' },
    { img: 'dollarCheckImg', title: 'YTD Gross Overdue', countKey: 'ytdOverdueCount', amountKey: 'ytdOverdueAmount', extraClass: 'border-right-0' }
  ];

  return (
    <>
      <div className="metrics_card_container mb-4">
        <div className="leads_detail_select_box">
          <AppForm ref={infoForm} onSubmit={(...args) => onSearch(...args)} className="row justify-content-end">
            <div className="col-12 col-md-3 col-lg-3 col-xl-2" id="column-paymentmode">
              <AppInputFocus type="select" name="paymentMode" label="Product Type" options={_enum.REPAYMENT_TYPES} onChange={(...args) => handlePaymentModeChange(...args)} placeholder="Product Type"></AppInputFocus>
            </div>
            {/* <div className="col-12 col-md-3 col-lg-3 col-xl-2" id="column-timeline">
              <AppInputFocus type="select" name="timeline" label="Time Line" options={_enum.OVERALL_DETAIL} onChange={(...args) => handleDateChange(...args)} defaultValue={"TODAY"} placeholder="Time Line"></AppInputFocus>
            </div> */}
            <div className="col-12 col-md-3 col-lg-3 col-xl-2 d-none" id="column-startDate">
              <AppInputFocus type="date" name="startDate" label="Start Date" placeholder="Start Date" required={true}></AppInputFocus>
            </div>
            <div className="col-12 col-md-3 col-lg-3 col-xl-2 d-none" id="column-endDate">
              <AppInputFocus type="date" name="endDate" label="End Date" placeholder="End Date" required={true}></AppInputFocus>
            </div>
            <div className="col-2 col-md-1 col-lg-1 col-xl-1 d-none" id="column-search_btn">
              <button type="submit" className="btn search_btn white_variant"><i className="fa fa-search"></i></button>
            </div>
            <div className="col-2 col-md-1 col-lg-1 col-xl-1 d-none" id="column-reset_btn">
              <button type="button" className="btn search_btn white_variant" onClick={(...args) => resetSearchForm(...args)}>
                <i className="fa-solid fa-filter-circle-xmark"></i>
              </button>
            </div>
          </AppForm>
        </div>

        <div className="row g-4 metrics_card_row">{row1Cards.map(renderCard)}</div>
        <div className="row g-4 metrics_card_row">{row2Cards.map(renderCard)}</div>
      </div>
    </>
  );
};

export default constore(OverallPortfolioSummaryCard);
